<template>
  <input
      class="bg-dark-form rounded-lg w-full p-3 disabled:text-gray-400"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)">
</template>

<script>
export default {
  name: "VInput",
  props: ['modelValue']
}
</script>

<style scoped>

</style>